import React from 'react'
import { StepItem } from './components'

import { EnumStepNames, StepsProps } from './props'
import { StepWrapper, OverflowContainer } from './styles'

const StepTitles = [
  {
    id: 1,
    title: EnumStepNames.SET_GENRES,
  },
  {
    id: 2,
    title: EnumStepNames.SET_REACH,
  },
  {
    id: 3,
    title: EnumStepNames.START_CAMPAIGN,
  },
]

export const Steps: React.FC<StepsProps> = ({
  currentStep = 1,
  setCurrentStep,
}) => {
  const onClickStep = (step: number) => {
    if (step < currentStep) setCurrentStep(step)
  }

  return (
    <OverflowContainer>
      <StepWrapper>
        {StepTitles.map(el => (
          <StepItem
            title={el.title}
            id={el.id}
            isCurrent={currentStep === el.id}
            isPassed={currentStep > el.id}
            key={el.id}
            onClick={() => onClickStep(el.id)}
          />
        ))}
      </StepWrapper>
    </OverflowContainer>
  )
}
